import React, { useEffect, useState } from "react";
import convert from "react-from-dom";
import PropTypes from "kf-proptypes/widgets";

import {
  KfIcon,
  KF_ICONS,
  ICON_SIZE,
  ICON_STROKE
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./styles.css";

export function SvgFromUrl({
  url,
  checkIsIconFailedtoFetch = () => {},
  className,
  iconColor,
  fallBackIconColor = "--kf-color-gray-400"
}) {
  const [svgElement, setSvgElement] = useState(null);
  const [isFetchError, setIsFetchError] = useState(false);

  useEffect(
    function onLoadSvg() {
      if (url) {
        fetch(url)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`svg error ${res.status}`);
            }
            return res.text();
          })
          .then((htmlstr) => {
            setSvgElement(convert(htmlstr));
            checkIsIconFailedtoFetch(false);
            setIsFetchError(false);
          })
          .catch((err) => {
            console.error("svg error", err);
            setIsFetchError(true);
            checkIsIconFailedtoFetch(true);
          });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [url]
  );

  return isFetchError ? (
    <div
      className={`${styles.iconContainer} ${styles.fallback}`}
      style={{
        "--icon-color": `var(${fallBackIconColor})`
      }}
    >
      <KfIcon
        icon={KF_ICONS.IMAGE_BROKEN}
        size={ICON_SIZE.SIZE_20}
        stroke={ICON_STROKE.BOLD}
      />
    </div>
  ) : (
    <div
      className={`${styles.iconContainer} ${className}`}
      style={{
        "--icon-color": `var(${iconColor})`
      }}
    >
      <>{svgElement}</>
    </div>
  );
}

SvgFromUrl.propTypes = {
  url: PropTypes.string,
  checkIsIconFailedtoFetch: PropTypes.func,
  className: PropTypes.string,
  iconColor: PropTypes.string,
  fallBackIconColor: PropTypes.string
};
